import Relay from 'react-relay';

export default class AddReportLinkMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{addReportLink}`;
  }

  getVariables() {
    return {
      conversationId: this.props.conversationId,
      linkToReport: this.props.linkToReport
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on addReportLinkPayload {
        conversation {
          linkToReport
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        conversation: this.props.conversationRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddReportLinkMutation.js
 **/